import { createContext, useContext } from 'react';
import type { IRequestsContext } from '../../../interfaces/requests.interface';

const RequestsContext = createContext<IRequestsContext | undefined>(undefined);

const useRequestsContext = () => {
    const context = useContext(RequestsContext);
    if (context === undefined) {
        throw new Error('useRequests must be used within a RequestsProvider');
    }
    return context;
};

export { RequestsContext, useRequestsContext };
